<div _ngcontent-pyd-c1="" class="header-container row">
  <div _ngcontent-pyd-c1="" class="mainMenu headerSpacer"><span _ngcontent-pyd-c1="">&nbsp;</span></div><div _ngcontent-pyd-c1="" class="logo"><a _ngcontent-pyd-c1="" ng-reflect-router-link="/" href="/"><img _ngcontent-pyd-c1="" alt="Kawneer logo" src="../../../assets/images/kawneer_logo.JPG"></a></div><div _ngcontent-pyd-c1="" class="login-bridge-block"></div><div _ngcontent-pyd-c1="" class="account-container">
    <div _ngcontent-pyd-c1="" class="account-menu-container">
    </div>
  </div>
  <!--bindings={
    "ng-reflect-ng-if": "false"
  }-->
</div>
<article>
  <h1>We&rsquo;ll be back soon!</h1>
  <div>
    <p>{{description}}</p>
    <p>Maintenance of KawneerDirect has started on <b>{{startTime|date:'medium'}} CST</b> and the website will be back up after <b>{{ backTime | date:'medium' }} CST</b></p>
    <p>&mdash; The KawneerDirect Admin</p>
  </div>
</article>
